import { render, staticRenderFns } from "./DlgConfirm.vue?vue&type=template&id=c5c6eb88&scoped=true"
import script from "./DlgConfirm.vue?vue&type=script&lang=js"
export * from "./DlgConfirm.vue?vue&type=script&lang=js"
import style0 from "./DlgConfirm.vue?vue&type=style&index=0&id=c5c6eb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c6eb88",
  null
  
)

export default component.exports